import { Alert, Button, Form, Input } from 'antd';
import type { RateLineImportRowView } from '../../../rate-cards.api';
import { isActionableRow } from '../policies/rate-line-import-row-status';
import { RateLineImportRowsTable } from './RateLineImportRowsTable';

interface RateLineImportPreviewPanelProps {
  rows: RateLineImportRowView[];
  reason: string;
  onReasonChange: (reason: string) => void;
  onCommit: () => void;
  onCancel: () => void;
  committing: boolean;
  commitError?: string;
}

/** The diff plus the one form field every proposal it opens is audited with — nothing commits without a reason. */
export function RateLineImportPreviewPanel({ rows, reason, onReasonChange, onCommit, onCancel, committing, commitError }: RateLineImportPreviewPanelProps) {
  const hasActionableRow = rows.some((row) => isActionableRow(row.status));

  return (
    <div className="flex flex-col gap-4">
      <RateLineImportRowsTable rows={rows} />
      {commitError && <Alert type="error" showIcon title="Could not commit the import" description={commitError} />}
      {!hasActionableRow ? (
        <Alert type="info" showIcon description="Nothing in this file is new or changed — there is nothing to commit." />
      ) : (
        <Form layout="vertical" onFinish={onCommit} disabled={committing}>
          <Form.Item label="Reason" required extra="Recorded on every proposal this import opens">
            <Input.TextArea rows={2} value={reason} onChange={(event) => onReasonChange(event.target.value)} />
          </Form.Item>
          <p className="mb-3 text-xs text-muted">Each row commits on its own — a row that fails won't stop the others in this file from opening their draft.</p>
          <div className="flex gap-2">
            <Button type="primary" htmlType="submit" loading={committing} disabled={!reason.trim()}>
              Commit import
            </Button>
            <Button onClick={onCancel} disabled={committing}>
              Cancel
            </Button>
          </div>
        </Form>
      )}
    </div>
  );
}
